module.exports = __webpack_public_path__ + "img/btt.c93a3331.svg";